import { useState, useEffect } from "react";

// ── useWindowWidth ────────────────────────────────────────────────────────────
const useWindowWidth = () => {
  const [w, setW] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : 1200,
  );
  useEffect(() => {
    const handler = () => setW(window.innerWidth);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return w;
};

export default useWindowWidth;
